import {
    PROMOTIONAL_CARD_BASE_CLASSNAME,
    PromotionalCard,
    createPromotionalCard,
} from '@vfde-brix/ws10/promotional-card';
import {
    NO_PATTERN_BUSINESS_LOGIC,
    createComponents,
} from '@vfde-brix/ws10/core';

/**
 * Mounts a PromotionalCard
 */
export const mountPromotionalCardById = (containerId: string): PromotionalCard | null => {
    const container = document.getElementById(containerId);

    /* istanbul ignore if */
    if (!container) {
        return null;
    }

    const promotionalCard = createPromotionalCard(container, NO_PATTERN_BUSINESS_LOGIC);

    return promotionalCard;
};

/**
 * Mounts all promotionalCards within the container with the given ID
 */
export const mountEditorialPromotionalCards = (containerId: string): void => {
    const container = document.getElementById(containerId);

    /* istanbul ignore if */
    if (!container) {
        return;
    }

    createComponents(
        `.${PROMOTIONAL_CARD_BASE_CLASSNAME}`,
        createPromotionalCard,
        NO_PATTERN_BUSINESS_LOGIC,
        container,
    );
};
